import { memo } from "react";
import { navigateToContent } from "../../utils/utils";
import styles from "./index.module.scss";

const RelatedSessionsMenu = ({ related }: { related: Array<any> }) => {
    return (
        <>
            {related?.map((t) => (
                <div key={t.value} className={styles.menu}>
                    <div className={styles.menuItem} onClick={() => navigateToContent(t.value)}>
                        Menu
                    </div>
                </div>
            ))}
        </>
    );
};

export default memo(RelatedSessionsMenu);